App.controller('LifeDataCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'statesService', '$q', '$filter', '$mdDialog', 'Config', '$timeout', '$anchorScroll', '$location', function ($scope, $sce, $state, $http, packageService, $stateParams, statesService, $q, $filter, $mdDialog, Config, $timeout, $anchorScroll, $location) {
        $scope.stateParams = $stateParams;

        $scope.page = 'life';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Wybierz wariant ubezpieczenia dla siebie i najbliższych (krok 3)';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.data';
        $scope.$emit('link', $scope.link);

        if ($scope.stateParams && $scope.stateParams.choose) {
            $scope.person = $scope.stateParams.person;
            $scope.persons = $scope.stateParams.persons;
            $scope.choose = $scope.stateParams.choose;
            $scope.prices = $scope.stateParams.prices;
            $scope.partner = $scope.stateParams.partner;
            $scope.assured = $scope.stateParams.assured;
            $scope.summary = $scope.stateParams.summary;
            $scope.isAssured = $scope.stateParams.isAssured;
            $scope.isPartner = $scope.stateParams.isPartner;
        } else {
            return $state.go('root.life.start');
        }

        if (Object.keys($scope.choose[1]).length) {
            if ($scope.isPartner) {
                $scope.persons[1].type = 'PARTNER';
                $scope.persons[1].person.firstName = $scope.partner.firstName;
                $scope.persons[1].person.lastName = $scope.partner.lastName;
                $scope.persons[1].person.citizenshipType = $scope.partner.citizenshipType;
                $scope.persons[1].person.otherCitizenship = $scope.partner.otherCitizenship;
                $scope.persons[1].person.identifier = $scope.partner.identifier;
                $scope.persons[1].person.gender = $scope.partner.gender;
                $scope.persons[1].person.birthplace = $scope.partner.birthplace;
                $scope.persons[1].person.birthdate = $scope.partner.birthdate;
            } else {
                $scope.persons[1].type = 'SPOUSE';
            }
        }

        $scope.realDeclarationsNumber = 0;

        $scope.fields = [
            {
                "name": "Śmierć ubezpieczonego"
            },
            {
                "name": "Śmierć w następstwie NW"
            },
            {
                "name": "Zgon ubezpieczonego spowodowany długim zdaniem, które nie mieści się w jenej linijce"
            }
        ];

    $scope.isLifePackageHidden = function (person, group, item) {
        return person > 0 && $scope.lifePackages[group].disabledForFamilyMembers;
    };

    packageService.dataLifeList().then(function (data) {

            $scope.lifePackages = data.data.group;

            if (!$scope.stateParams.prices) {
                if (!$scope.persons) {
                    $state.go('root.life.start');
                }
            }
        });

        $scope.accept = function () {
            $scope.form.$setSubmitted();
            $scope.next($scope.form);
        };

        $scope.next = function () {
            var vm = this;

            vm.form.$submitted = true;
            if (!vm.form.$valid) {
                // $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
                // document.body.scrollTop = document.documentElement.scrollTop = 80;
                return 0;
            }
            if (!Object.keys($scope.choose[0]).length) {
                $scope.showPopUp('', 'Niepoprawnie wybrany wariant', 'Musisz wybrać co najmniej jeden wariant dla siebie (Ubezpieczony pracownik)');
                return 0;
            }


            var isPercentageValid = true;
            var isAgeValid = true;
            angular.forEach($scope.persons, function (singlePerson) {
                if (!singlePerson['hideForm']) {
                    if (singlePerson.type !== 'USER') {
                        // Validate age for type PARTNER and CHILD;
                        // if (!validateAge(singlePerson.person)) {
                        //     isAgeValid = false;
                        // }
                        if (!$scope.notCheckValidAge) {
                            if (!validateAge(singlePerson.person)) {
                                isAgeValid = false;
                            }
                        }
                    }
                }

                if (!isPercentageValid) {
                    return;
                }
                if (singlePerson.type === 'USER') {
                    return;
                }
                if (!singlePerson.isAssured) {
                    return;
                }
                isPercentageValid = $filter('percentageOfBenefit')(singlePerson.assured);
            });

            if (!isAgeValid) {
                return;
            }

            if (!isPercentageValid) {
                $scope.showPopUp('', 'Nieprawidłowy procent świadczegnia', 'Procent świadczenia dla wszystkich uposażonych musi się sumować do 100%');
                return;
            }

            var data = {
                choose: $scope.choose,
                prices: $scope.prices,
                summary: $scope.summary,
                assured: $scope.assured,
                partner: $scope.partner,
                persons: $scope.persons,
                person: $scope.person,
                isAssured: $scope.isAssured,
                isPartner: $scope.isPartner
            };

            if (isIdentifiersValid(data)) {
                $state.go('root.life.confirmation', data);
            } else {
                $scope.showPopUp('', 'Zgłaszane osoby mają ten sam nr PESEL - sprawdź wypełnione pola', '');
            }
        };

        var getResults = function (query) {
            var deferred = $q.defer();

            statesService.dataCityLists({
                name: query
            }).then(function (data) {
                deferred.resolve(data.data);
            });

            return deferred.promise;
        };

        // ##### LOCALIZATION FILTER ##### //
        $scope.querySearchLocalization = function (query) {
            if (!query) {
                return;
            }

            return getResults(query).then(function (results) {
                return results;
            });
        };

        $scope.showPopUp = function (ev, head, content, text, target, notClose, nextStep) {
            $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
                targetEvent: ev,
                clickOutsideToClose: !notClose,
                locals: {
                    head: head,
                    content: content,
                    button: {
                        text: text,
                        target: target
                    },
                    notClose: !notClose,
                    nextStep: nextStep
                }
            }).then(function (data) {
                if (data.confirm && data.nextStep) {
                    $scope.notCheckValidAge = true;
                    $scope.next();
                }
            }, function () {

            });
        };

        function PopUpInfoCtrl($scope, $mdDialog, locals) {
            $scope.locals = locals;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                $scope.locals.confirm = true;
                $mdDialog.hide($scope.locals);
            };
        }
        PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

        /**
         * Check if a person complies with the age restrictions;
         *
         * @param person
         * @returns {*} boolean
         */
        function validateAge(person) {
            if (person.citizenshipType === 'POLISH') {
                if ($filter('isNoAdultFromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return false;
                }
                if ($filter('isOver75FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }
            } else {
                if ($filter('isNoAdultFromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return false;
                }
                if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }
            }
            return 1;
        }

        function isIdentifiersValid(data) {
            console.log(data.choose, data.persons);
            var identifiers = [];

            if (data.person.citizenshipType === 'POLISH') {
                identifiers.push({
                    type: 'USER',
                    identifier: data.person.identifier
                });
            }

            angular.forEach(data.persons, function (singlePerson, i) {
                if ((singlePerson.type === 'PARTNER' || singlePerson.type === 'SPOUSE' || singlePerson.type === 'CHILD') && singlePerson.person.citizenshipType === 'POLISH') {
                    console.log(data.choose, 'index', i, 'single-choose', data.choose[i], 'single-person', singlePerson);

                    if (singlePerson.hideForm || typeof data.choose[i] === "undefined" || !Object.keys(data.choose[i]).length) {
                        return;
                    }

                    identifiers.push({
                        type: singlePerson.type,
                        identifier: singlePerson.person.identifier
                    });

                    if (singlePerson.isPartner && singlePerson.partner && singlePerson.partner.citizenshipType === 'POLISH') {
                        identifiers.push({
                            type: 'PARTNER',
                            of: singlePerson.type,
                            identifier: singlePerson.partner.identifier
                        });
                    }
                }

            });

            console.log(identifiers);

            for (var a = 0; a < identifiers.length; a++) {
                var personA = identifiers[a];
                for (var b = 0; b < identifiers.length; b++) {
                    var personB = identifiers[b];
                    console.log('isIdentifierValid', a, b, personA, personB);
                    if (a === b) {
                        continue;
                    }
                    if (personA.identifier === personB.identifier) {
                        return false;
                    }
                }
            }
            return true;
        }

        $scope.$watch('persons', function(oldVal, newVal) {
          console.log(oldVal, newVal);
          if (oldVal !== newVal) {
            for (var b = 0; b < $scope.persons.length; b++) {

                if ($scope.persons[b].type !== 'USER' && $scope.persons[b].assured) {
                    for (var a = 0; a < $scope.persons[b].assured.length; a++) {
                      if ($scope.persons[b].assured[a].type === 'ORGANIZATION' && !$scope.persons[b].assured[a].wasChangeAddres) {
                          $scope.persons[b].assured[a].sameAddress = false;
                          $scope.persons[b].assured[a].city = '';
                          $scope.persons[b].assured[a].street = '';
                          $scope.persons[b].assured[a].number = '';
                          $scope.persons[b].assured[a].apartment = '';
                          $scope.persons[b].assured[a].zipCode = '';
                          $scope.persons[b].assured[a].wasChangeAddres = true;
                      }
                      if ($scope.persons[b].assured[a].sameAddress && $scope.persons[b].person.address) {
                        $scope.persons[b].assured[a].city = $scope.persons[b].person.address.city;
                        $scope.persons[b].assured[a].street = $scope.persons[b].person.address.street;
                        $scope.persons[b].assured[a].number = $scope.persons[b].person.address.number;
                        $scope.persons[b].assured[a].apartment = $scope.persons[b].person.address.apartment;
                        $scope.persons[b].assured[a].zipCode = $scope.persons[b].person.address.zipCode;
                      }
                    }
                }
            }
          }
        }, true);



    /**
     * Scroll to inputs on init;
     */
    (function () {
        $timeout(function () {
            // Always scroll by 70 extra pixels (navbar height)
            $anchorScroll.yOffset = 70;
            $location.hash('form');
        });
    })();
    }
]);
